import { css, cx } from "@emotion/css";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import config from "config";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isIos } from "src/capacitor/appsHelpers";
import { IconButton } from "src/components/Default/LekUI/Button";
import { Popper } from "src/components/Default/LekUI/Popper";
import { TextFieldGrey } from "src/components/Default/LekUI/TextField";
import { Loading } from "src/components/TextEditor";
import ArrowNextIcon from "src/images/Icons/newIcons/controllers/arrowNext.svg";
import PesIcon from "src/images/Icons/pesIcon.svg";
import isPes from "../../helpers/isPes";
import {
	getUserInfo,
	getUserSpecialisationName,
	useGetSpecialisations,
	useSetSpecialisation,
} from "../../hooks/useUser";

export const PesInfo = () => {
	const { mutateAsync, isPending: isSettingSepc } = useSetSpecialisation();
	const { data: specializations = [], isLoading } = useGetSpecialisations();
	const user = getUserInfo();
	const { t } = useTranslation();
	const [searchText, setSearchText] = useState("");

	if (!isPes()) {
		return null;
	}

	const userSpec = getUserSpecialisationName();

	if (!userSpec || isLoading) {
		return null;
	}

	const specToBuy = specializations.filter((spec: any) => {
		return !user.availableSpecialisations.some((s: any) => s.id === spec.id);
	});

	const filteredSpecializations = specToBuy.filter((spec: any) => {
		return spec.specialisation.toLowerCase().includes(searchText.toLowerCase());
	});

	const filteredAvailableSpecialisations = user.availableSpecialisations.filter(
		(spec: any) => {
			return spec.specialisation
				.toLowerCase()
				.includes(searchText.toLowerCase());
		},
	);

	return (
		<Popper
			className={cx(css`
        z-index: 9999 !important;
        min-width: min(500px, 100%);
      `)}
			renderTrigger={({
				setAnchor,
			}: {
				setAnchor: (e: React.MouseEvent) => void;
			}) => (
				<div className="profile--user-pes-info" onClick={setAnchor}>
					<div className="profile--user-pes-info--icon">
						<PesIcon className="icon-normal" />
					</div>
					<div className="flex flex-col">
						<h3 className="m-0 size-14">PES</h3>
						<span className="size-12-light text-ellipsis-1">{userSpec}</span>
					</div>
				</div>
			)}
		>
			{({ closePopper }: { closePopper: (e: React.MouseEvent) => void }) => (
				<Loading
					{...({ isLoading: isLoading || isSettingSepc } as any)}
					size="small"
					className={cx(css`
            margin: -8px 0;

            > div:first-of-type {
              border-radius: 6px;
            }
          `)}
				>
					<div className={cx("profile--user-pes-info--list ofy-scroll")}>
						<span className="size-18">Specjalizacje</span>
						<TextFieldGrey
							autoFocus
							variant="outlined"
							margin="none"
							fullWidth
							placeholder={t("filters.exams.departments.search")}
							value={searchText}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
								setSearchText(e.target.value)
							}
							size="small"
						/>
						<span className="size-16-light text-grey my-4">Specjalizacje</span>
						<List className={cx("p-0")}>
							{filteredAvailableSpecialisations?.map((spec: any) => (
								<ListItem
									onClick={() => (mutateAsync as any)({ id: spec.id })}
									key={spec.id}
									className="m-0 pl-4 pr-0 list-item"
								>
									<ListItemText primary={spec.specialisation} />
									<IconButton>
										<ArrowNextIcon className="icon-super-small" />
									</IconButton>
								</ListItem>
							))}
						</List>
						{!isIos() && !!filteredSpecializations.length && (
							<>
								<div className="flex">
									<span className="divider divider--horizontal" />
								</div>
								<span className="size-16-light text-grey my-4">Kup dostęp</span>
								<List className={cx("p-0")}>
									{filteredSpecializations?.map((spec: any) => (
										<ListItem key={spec.id} className="m-0 py-0 px-4">
											<ListItemText primary={spec.specialisation} />
											<a
												href={`${config.urls.pricingPes}${spec.id}`}
												target="_blank"
												rel="noreferrer noopener"
												className={cx(
													"py-2 px-4 lek-primary-button",
													css`
                              height: 24px !important;
                            `,
												)}
											>
												Kup +
											</a>
										</ListItem>
									))}
								</List>
							</>
						)}
					</div>
				</Loading>
			)}
		</Popper>
	);
};
